import React from 'react';
import { maskMoney, maskRichText } from '../../masks';
import SVGTrash from '../../svg/Trash';

class MenuDishEdit extends React.Component {
  render() {
    const { courseIndex, dishIndex, dish, deleteDish } = this.props;
    return (
      <tr className="table__tr--border">
        <td className="table__td menu-dish__edit menu-dish__edit--name">
          <p className="p">
            {dish.name || ''}{' '}
            <span className="p--em p--new-line">{dish.child_name || ''}</span>
          </p>
        </td>
        <td className="table__td menu-dish__edit menu-dish__edit--ingredients">
          {maskRichText(dish.public_ingredients || '<p></p>')}
        </td>
        <td className="table__td menu-dish__edit menu-dish__edit--price">
          <p className="p">{maskMoney(dish.price_cents) || '-'}</p>
        </td>
        <td className="table__td menu-dish__edit menu-dish__edit--diet">
          <p className="p">
            {this.renderDiet(dish.dietary_preference_tags) || '-'}
          </p>
        </td>
        <td className="table__td menu-dish__edit menu-dish__edit--allergens">
          <p className="p">{this.renderAllergens(dish.allergens) || '-'}</p>
        </td>
        <td className="table__td menu-dish__edit menu-dish__edit--edit">
          <div
            className="a--blue"
            onClick={() =>
              this.handleEdit({
                courseIndex,
                dishIndex: dishIndex,
                activeDish: dish
              })
            }
          >
            Edit
          </div>
        </td>
        <td className="table__td table__td--border-left  menu-dish__edit menu-dish__edit--trash">
          <span
            className="btn-icon btn-icon--trash"
            onClick={() => deleteDish(courseIndex, dish)}
          >
            <SVGTrash />
          </span>
        </td>
      </tr>
    );
  }

  renderDiet(diets) {
    return diets.map(diet => diet.abbreviation).join(', ') || '-';
  }

  renderAllergens(allergens) {
    return allergens.map(allergen => allergen.tag).join(', ') || '-';
  }

  handleEdit = payload => {
    // if dish is private child- trigger new page
    if (payload.activeDish && payload.activeDish.child_private) {
      this.props.openModal('', payload); // fun hack to update the indexes
      this.props.editMenuDish(payload.activeDish);
    }
    // otherwise pop modal
    else this.props.openModal('edit-dish', payload);
  };
}

export default MenuDishEdit;



// WEBPACK FOOTER //
// ./src/components/menu/MenuDishEdit.js